import { ovl } from "."
import { ovlFetch, SYSFetchResult } from "./effects"

type DataOptions = {
  customUrl?: string
  method?: "POST" | "GET"
  ignoreSnack?: boolean
  expectBlob?: boolean
  isFormData?: boolean
  isAuthCheck?: boolean
}

export const Data = async (
  endpoint,
  data?,
  options?: DataOptions
): Promise<SYSFetchResult> => {
  if (data === undefined) {
    data = {}
  }
  let url = options?.customUrl
  if (!url) {
    url = `${ovl.getState().ovl.apiUrl}${endpoint}`
  }
  let method = options?.method
  if (!method) {
    method = "POST"
  }
  let expectBlob = options?.expectBlob
  if (expectBlob === undefined) {
    expectBlob = false
  }
  let ignoreSnack = options?.ignoreSnack
  if (ignoreSnack === undefined) {
    ignoreSnack = false
  }
  let isFormData = options?.isFormData
  if (isFormData === undefined) {
    isFormData = false
  }
  return await ovlFetch(
    url,
    data,
    method,
    expectBlob,
    ignoreSnack,
    undefined,
    isFormData,
    options?.isAuthCheck
  )
}
